import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  KioskGlobalSettingsState,
  KIOSK_GLOBAL_SETTINGS_STORE_KEY,
} from './kiosk-global-settings.state';

export const selectKioskGlobalSettingsState = createFeatureSelector<KioskGlobalSettingsState>(
  KIOSK_GLOBAL_SETTINGS_STORE_KEY,
);

export const selectKioskGlobalSettings = createSelector(
  selectKioskGlobalSettingsState,
  (state: KioskGlobalSettingsState) => state.settings,
);

export const selectProductCardChoice = createSelector(
  selectKioskGlobalSettingsState,
  productCard => productCard.settings.productCard.choice,
);

export const selectProductCardColSpan = createSelector(selectProductCardChoice, cardChoice => {
  return [4, 6].includes(cardChoice) ? 2 : 1;
});
